module.exports = __webpack_public_path__ + "../resources/img/bg_storage1_02.8479ce47.png";